export default "<p>reeducando works!</p>\n"